import { z } from 'my-zod'
import { customerWaiversModel } from './customer-waivers-model'
import { operatorsModel } from '../../outfitter-account-management/outfitter'

export const customerWaiversSystemView = customerWaiversModel.augment({
  customerId: z.string().uuid().nullable(),
  operatorName: operatorsModel.shape.businessName.nullish(),
  preferredLanguage: z.string().nullish(),
  isDLPhotoNeeded: z.boolean().nullish()
})

export type customerWaiversSystemView = z.infer<typeof customerWaiversSystemView>
